import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert } from 'reactstrap';
import qs from 'qs';

import _get from 'lodash/get';
import _toLower from 'lodash/toLower';

import { UiKit } from 'components';
import { useForm } from 'utils/hooks';
import { fetchRetailers } from 'utils/services';
import { FORM_SCHEMA } from './stubs';

export default function StepOne({ onSubmit = () => {} }) {
  const { search } = useLocation();
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true });

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { data, errors, onChange, onValidate } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: { email: _get(queryParams, 'email', '') }
  });

  const onFormSubmit = e => {
    e.preventDefault();

    const isValid = onValidate(data);
    if (!isValid) return;

    setIsLoading(true);
    const email = _toLower(_get(data, 'email', '')).trim();
    fetchRetailers(
      { email },
      retailers => onSubmit({ email, retailers }),
      () => setIsError(true),
      () => setIsLoading(false)
    );
  };

  const onEmailChange = value => {
    onChange({ email: value }, { runValidation: !!errors.email });
  };

  return (
    <UiKit.Grid templateColumns="1fr" gap="16">
      <Alert
        color="danger"
        isOpen={isError}
        toggle={() => setIsError(false)}
        className="mb-0"
      >
        Unable to fetch the user information at the moment.
      </Alert>
      <form onSubmit={onFormSubmit}>
        <UiKit.Grid templateColumns="1fr" gap="16">
          <UiKit.Input
            autoFocus
            type="email"
            value={data.email}
            onChange={onEmailChange}
            placeholder="Enter your email address"
            error={errors.email}
            disabled={isLoading}
          />
          <UiKit.Button type="submit" className="w-100" processing={isLoading}>
            Start
          </UiKit.Button>
        </UiKit.Grid>
      </form>
    </UiKit.Grid>
  );
}
